import React from 'react';
import Meus_Pedidos from '../../Meus_Pedidos/Meus_Pedidos';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';

export default function (props) {
  
  return (
    <>
   <NavBarTop />
     <Meus_Pedidos props={props} />
   <Rodape />
    </>
  )
}